import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-order-save-menu',
  templateUrl: './order-save-menu.component.html',
})
export class OrderSaveMenuComponent {
  @Input() orderForm: FormGroup;
  @Input() variant: 'order' | 'repair' = 'order';
  @Output() saveOrder = new EventEmitter<{ destination: string }>();

  get isDispensed(): boolean {
    return this.orderForm?.get('status')?.value === 'DISPENSED';
  }

  onSave(destination: string): void {
    this.saveOrder.emit({ destination });
  }
}
